import { render } from "./ViewWorkbench.vue?vue&type=template&id=e6cdf060&scoped=true&ts=true"
import script from "./ViewWorkbench.vue?vue&type=script&lang=ts"
export * from "./ViewWorkbench.vue?vue&type=script&lang=ts"

import "./ViewWorkbench.vue?vue&type=style&index=0&id=e6cdf060&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6cdf060"],['__file',"src/views/ViewWorkbench.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6cdf060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6cdf060', __exports__)) {
    api.reload('e6cdf060', __exports__)
  }
  
  module.hot.accept("./ViewWorkbench.vue?vue&type=template&id=e6cdf060&scoped=true&ts=true", () => {
    api.rerender('e6cdf060', render)
  })

}


export default __exports__